var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6875 1.99609C4.01823 0.665365 5.6224 0 7.5 0C9.3776 0 10.9727 0.665365 12.2852 1.99609C13.6159 3.30859 14.2812 4.90365 14.2812 6.78125C14.2812 8.65885 13.6159 10.263 12.2852 11.5938C10.9727 12.9062 9.3776 13.5625 7.5 13.5625C5.6224 13.5625 4.01823 12.9062 2.6875 11.5938C1.375 10.263 0.71875 8.65885 0.71875 6.78125C0.71875 4.90365 1.375 3.30859 2.6875 1.99609ZM3.61719 10.6641C4.69271 11.7214 5.98698 12.25 7.5 12.25C9.01302 12.25 10.2982 11.7214 11.3555 10.6641C12.431 9.58854 12.9688 8.29427 12.9688 6.78125C12.9688 5.26823 12.431 3.98307 11.3555 2.92578C10.2982 1.85026 9.01302 1.3125 7.5 1.3125C5.98698 1.3125 4.69271 1.85026 3.61719 2.92578C2.5599 3.98307 2.03125 5.26823 2.03125 6.78125C2.03125 8.29427 2.5599 9.58854 3.61719 10.6641ZM9.19531 9.40625L6.87109 7.71094C6.77995 7.63802 6.73438 7.54688 6.73438 7.4375V2.95312C6.73438 2.73438 6.84375 2.625 7.0625 2.625H7.9375C8.15625 2.625 8.26562 2.73438 8.26562 2.95312V6.83594L10.0977 8.14844C10.2617 8.27604 10.2799 8.43099 10.1523 8.61328L9.66016 9.32422C9.53255 9.50651 9.3776 9.53385 9.19531 9.40625Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockImg);
export default __webpack_public_path__ + "static/media/clockImg.5a015b7cca2712e7d7140fe6a7451ad9.svg";
export { ForwardRef as ReactComponent };